// LocationMimicBar.tsx
import { Button } from '@/components/shared/button/Button';
import { isAdmin, useAuthenticationService } from '@/services/authentication/authentication-service';
import { useAdminLocationStore } from '@/services/location/useAdminLocationStore';
import React from 'react';
import { MdExitToApp } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import strings from './tenantManagement.translations';

export const LocationMimicBar: React.FC = () => {
  const navigate = useNavigate();

  const { actingLocation: selectedLocation, setActingLocation: setSelectedLocation } = useAdminLocationStore();

  const role = useAuthenticationService(state => state.role);

  const isUserAdmin = isAdmin(role);
  if (!isUserAdmin || !selectedLocation) return null;

  const exitMimicMode = () => {
    setSelectedLocation(undefined);
    navigate('/', { replace: true });
  };

  return (
    <div className="bg-secondary-500 text-white px-4 py-3 flex justify-between items-center shadow-md font-medium z-50">
      <span>{strings.locationMimicBar?.editingLocation(selectedLocation.name)}</span>

      <Button onClick={exitMimicMode} className="flex items-center gap-1">
        <MdExitToApp size={18} />
        {strings.locationMimicBar?.exit || 'Exit Location Mode'}
      </Button>
    </div>
  );
};
